<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense dark>
        <v-toolbar-title>Category Details</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/product/categories">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- editor -->
        <editor :docCreate="docCreate" :initial="dataItem" @data="save"></editor>
        <!-- end -->
      </v-card-text>
    </v-card>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import Editor from "../_components/editor.vue";
export default {
  components: {
    Editor,
  },
  data: () => ({
    dataItem: {},
    docCreate: false
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.dataItem = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    save(data) {
      const url = `/products-categories/${data.id}`;
      const self = this;
      this.$store
        .dispatch("put", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$router.push("/product/categories");
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("btnLoader", false);
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
};
</script>